import jwtDecode from "jwt-decode";
const ENTRYPOINT = (process.env.REACT_APP_API_BASE as string);

interface IToken {
  "iat": number,
  "exp": number,
  "roles": string[],
  "username": string
}

const authProvider = {
  login: ({ username, password } : {username: string, password: string}) => {
    const request = new Request(
      `${ENTRYPOINT}/authentication_token`,
      {
        method: "POST",
        body: JSON.stringify({ email: username, password }),
        headers: new Headers({ "Content-Type": "application/json" }),
      }
    );
    return fetch(request)
      .then((response) => {
        if (response.status < 200 || response.status >= 300) {
          throw new Error(response.statusText);
        }
        return response.json();
      })
      .then(({ token }) => {
        const decodedToken = jwtDecode<IToken>(token);
        localStorage.setItem('token', token);
        localStorage.setItem('roles', JSON.stringify(decodedToken.roles));
      });
  },
  logout: () => {
    localStorage.removeItem("token");
    return Promise.resolve();
  },
  checkAuth: () => {
    try {
      // @ts-ignore
      if (!localStorage.getItem("token") || new Date().getTime() / 1000 > jwtDecode(localStorage.getItem("token"))?.exp) {
        return Promise.reject();
      }
      return Promise.resolve();
    } catch (e) {
      // override possible jwtDecode error
      return Promise.reject();
    }
  },
  checkError: (err: any) => {
    if ([401, 403].includes(err?.status || err?.response?.status)) {
      localStorage.removeItem("token");
      return Promise.reject();
    }
    return Promise.resolve();
  },
  getPermissions: () => {
    const roles = localStorage.getItem('roles');
    return roles ? Promise.resolve(JSON.parse(roles)) : Promise.reject();
  }
};

export default authProvider;
